import { useEffect, useMemo } from 'react'
import type { NextPage } from 'next'

import { useRouter } from 'next/router'

import { Theory } from '~/encyclopedia/components/Theory'
import { PreviewTopic, Topic, TopicOverview } from '~/types/theory'
import TopicMetatags from '~/components/Metadata/TopicMetatags'
import { setShowSubscriptionStaticModalCreator } from '~/redux/slices/modals'
import { useAppDispatch } from '~/redux/hooks'
import useSubscriptionWallForFamily from '~/subscription/hooks/useSubscriptionWallForFamily'
import { digitalToolsItems } from '~/shared/constants/digitalTools.const'

interface TexProps {
  articleBody: string
  topic: Topic
  topicOverview: TopicOverview[]
  previewTopics: PreviewTopic[]
}

const TheoryPage: NextPage<TexProps> = ({ articleBody, topic, topicOverview, previewTopics }) => {
  const router = useRouter()
  const dispatch = useAppDispatch()
  const isDigitalToolsItem = useMemo(() => {
    return Boolean(digitalToolsItems?.map(({ path }) => path).some((path) => router.asPath?.startsWith(path)))
  }, [router.asPath])

  const subscriptionIsRequired = useSubscriptionWallForFamily(
    isDigitalToolsItem ? `/digital-tools${router.asPath}` : undefined,
  )

  useEffect(() => {
    if (isDigitalToolsItem) {
      subscriptionIsRequired()
    } else {
      dispatch(setShowSubscriptionStaticModalCreator(false))
    }
  }, [dispatch, isDigitalToolsItem, subscriptionIsRequired])

  return (
    <div>
      <TopicMetatags topic={topic} />
      <Theory articleBody={articleBody} previewTopics={previewTopics} topic={topic} topicOverview={topicOverview} />
    </div>
  )
}

export default TheoryPage
